module.exports = __webpack_public_path__ + "img/icon_pdf_lock.d417c39.svg";